import React from 'react'
import Map from "../components/map"

const Office = ({name, email, phone, address, mail, lat, lng}) =>{
    return(
        <div className="office">
            <p className="uppercase m0 bb1 pb10 mb20">{name}</p>
            <div className="office-contact mb40">
                <span className="uppercase small">E</span>
                <a className="link sainte" href={"mailto:"+email}>{email}</a>
                <span className="uppercase small">T</span>
                <a className="link sainte" href={"tel:"+phone}>{phone}</a>
                <span className="uppercase small">A</span>
                <a className="link sainte" target="_blank" rel="noreferrer" href={"https://www.google.com/maps/place/"+encodeURIComponent(address)}>{address}</a>
                <span className="uppercase small">M</span>
                <span className="sainte">{mail}</span>
            </div>
            <Map lat={lat} lng={lng} />
        </div>
    )
}
export default Office
